import { Button, Dialog, DialogActions, DialogContent, DialogTitle, IconButton, Slide, Typography } from '@material-ui/core';
import { TransitionProps } from '@material-ui/core/transitions';
import { Close } from '@material-ui/icons';
import React, { Component } from 'react';

interface UIState {
	isOpen: boolean;
}

interface Props {
	open: boolean;
	children: React.ReactElement;
	title?: string;
	className?: string;
	actionBtnText?: string;
	hideActionBtns?: boolean;
	hideHeader?: boolean;
	maxWidth?: 'xs' | 'sm' | 'md' | 'lg' | 'xl';
	animate?: boolean;
	onAction?: () => void;
	onClose: () => void;
}

const Transition = React.forwardRef(function Transition(
	props: TransitionProps & { children?: React.ReactElement<any, any> },
	ref: React.Ref<unknown>,
) {
	return <Slide direction="up" ref={ref} {...props} />;
});

class CustomDialog extends Component<Props> {
	state: UIState = {
		isOpen: this.props.open,
	};

	onClose = () => {
		this.setState({ isOpen: false });
	};

	render() {
		return (
			<div>
				{this.props.animate && (
					<Dialog
						maxWidth={this.props.maxWidth || 'xs'}
						fullWidth
						onClose={this.props.onClose}
						className={`custom-dialog ${!!this.props.className ? this.props.className : ''}`}
						aria-labelledby="customized-dialog"
						open={this.props.open}
						TransitionComponent={Transition}
						keepMounted
					>
						{this.getDialogBody(this.props)}
					</Dialog>
				)}
				{!this.props.animate && (
					<Dialog
						maxWidth={this.props.maxWidth || 'xs'}
						fullWidth
						onClose={this.props.onClose}
						className={`custom-dialog ${!!this.props.className ? this.props.className : ''}`}
						aria-labelledby="customized-dialog"
						open={this.props.open}
					>
						{this.getDialogBody(this.props)}
					</Dialog>
				)}
			</div>
		);
	}

	getDialogBody = (props: Props) => (
		<>
			{!props.hideHeader && (
				<DialogTitle disableTypography className="dialog-header text--uppercase">
					<IconButton aria-label="close" className="close" onClick={this.props.onClose}>
						<Close />
					</IconButton>
				</DialogTitle>
			)}

			<DialogContent className="content">
				<Typography variant="h4" className="title">
					{this.props.title}
				</Typography>
				{this.props.children}
			</DialogContent>

			<DialogActions className="action-wrapper">
				{!this.props.hideActionBtns && (
					<Button className="action-button-1" onClick={this.props.onAction}>
						{this.props.actionBtnText}
					</Button>
				)}
			</DialogActions>
		</>
	);
}

export default CustomDialog;
